/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DeletedTombstoneContainer_comment = {
    readonly deleted: boolean | null;
    readonly " $refType": "DeletedTombstoneContainer_comment";
};
export type DeletedTombstoneContainer_comment$data = DeletedTombstoneContainer_comment;
export type DeletedTombstoneContainer_comment$key = {
    readonly " $data"?: DeletedTombstoneContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"DeletedTombstoneContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletedTombstoneContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deleted",
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '5535d63bf48f9918e936c796fa079bfb';
export default node;
